import { render } from "./top-menu.vue?vue&type=template&id=43e48d1c&scoped=true&ts=true"
import script from "./top-menu.vue?vue&type=script&lang=ts"
export * from "./top-menu.vue?vue&type=script&lang=ts"

import "./top-menu.vue?vue&type=style&index=0&id=43e48d1c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e48d1c"]])

export default __exports__